"use client";

import React from "react";
import "./Delete_Modal.css";

import { Modal } from "react-bootstrap";
import Gray_Btn from "../../../../common-components/common_btn/gray_btn/Gray_Btn";
import Green_btn from "../../../../common-components/common_btn/green_btn/Green_btn";

const Delete_Modal = (props) => {
  const {
    show,
    onHide,
    onConfirm,
  } = props;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal
      className="Delete_Modal delete_popup"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Body>

        <p className="modal_title">
          Are you sure you want to delete address?
        </p>

        <div className="btn_holder">

          <Gray_Btn
            btnText="No"
            onClick={() => {
              onHide();
            }}
          />

          <Green_btn
            btnText="Yes"
            onClick={handleConfirm}
          />

        </div>

      </Modal.Body>
    </Modal>
  );
};

export default Delete_Modal;